const user = JSON.parse(localStorage.getItem("_bnac"));
let token = "";

if (user && user.token) {
  token = user.token;
}
export const authHeader =  () => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
    // 'x-access-token': token,
  };
  return headers;
};

export const multipartHeader = () => {
  const headers = {
    "x-access-token": token,
  };
  return headers;
};

/** Multipart (FormData): do not set Content-Type. Bearer for routes that use JWT (e.g. product ratings). */
export const bearerMultipartHeader = () => {
  const u = JSON.parse(localStorage.getItem("_bnac") || "null");
  const freshToken = u?.token || "";
  const headers = {
    Accept: "application/json",
  };
  if (freshToken) {
    headers.Authorization = `Bearer ${freshToken}`;
  }
  return headers;
};

export default { authHeader, multipartHeader, bearerMultipartHeader };
